package com.eladfinish.bible.contest.network.cache

import io.ktor.client.plugins.cache.storage.CacheStorage

actual class CacheHelper {
    // In memory, for the life of the page. The browser's own HTTP cache already persists
    // responses across page loads, underneath ktor's fetch-based engine.
    actual fun getCacheStorage(): CacheStorage = CacheStorage.Unlimited()
}
